// extracted by mini-css-extract-plugin
export var layout = "b_b";